import { __makeTemplateObject } from "tslib";
import styled, { css } from "styled-components";
export var WrapperContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  gap: ", ";\n  align-items: ", ";\n  width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  background-color: ", ";\n  background: ", ";\n  padding: ", ";\n  margin: ", ";\n  text-align: ", ";\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  right: ", ";\n  left: ", ";\n  box-shadow: ", ";\n  justify-content: ", ";\n  border: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  z-index: ", ";\n\n  ", "\n"], ["\n  display: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  gap: ", ";\n  align-items: ", ";\n  width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  background-color: ", ";\n  background: ", ";\n  padding: ", ";\n  margin: ", ";\n  text-align: ", ";\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  right: ", ";\n  left: ", ";\n  box-shadow: ", ";\n  justify-content: ", ";\n  border: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  z-index: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.$display, $display = _b === void 0 ? "flex" : _b;
    return $display;
}, function (_a) {
    var _b = _a.$flexDirection, $flexDirection = _b === void 0 ? "row" : _b;
    return $flexDirection;
}, function (_a) {
    var _b = _a.$flexWrap, $flexWrap = _b === void 0 ? "none" : _b;
    return $flexWrap;
}, function (_a) {
    var _b = _a.$gap, $gap = _b === void 0 ? "1rem" : _b;
    return $gap;
}, function (_a) {
    var _b = _a.$alignItems, $alignItems = _b === void 0 ? "normal" : _b;
    return $alignItems;
}, function (_a) {
    var _b = _a.$width, $width = _b === void 0 ? "100%" : _b;
    return $width;
}, function (_a) {
    var _b = _a.$maxWidth, $maxWidth = _b === void 0 ? "inherit" : _b;
    return $maxWidth;
}, function (_a) {
    var _b = _a.$height, $height = _b === void 0 ? "100%" : _b;
    return $height;
}, function (_a) {
    var _b = _a.$minHeight, $minHeight = _b === void 0 ? "100%" : _b;
    return $minHeight;
}, function (_a) {
    var _b = _a.$maxHeight, $maxHeight = _b === void 0 ? "initial" : _b;
    return $maxHeight;
}, function (_a) {
    var _b = _a.$backgroundColor, $backgroundColor = _b === void 0 ? "inherit" : _b;
    return $backgroundColor;
}, function (_a) {
    var _b = _a.$background, $background = _b === void 0 ? "" : _b;
    return $background;
}, function (_a) {
    var _b = _a.$padding, $padding = _b === void 0 ? "1rem" : _b;
    return $padding;
}, function (_a) {
    var _b = _a.$margin, $margin = _b === void 0 ? "0" : _b;
    return $margin;
}, function (_a) {
    var _b = _a.$textAlign, $textAlign = _b === void 0 ? "center" : _b;
    return $textAlign;
}, function (_a) {
    var _b = _a.$position, $position = _b === void 0 ? "" : _b;
    return $position;
}, function (_a) {
    var _b = _a.$top, $top = _b === void 0 ? "auto" : _b;
    return $top;
}, function (_a) {
    var _b = _a.$bottom, $bottom = _b === void 0 ? "auto" : _b;
    return $bottom;
}, function (_a) {
    var _b = _a.$right, $right = _b === void 0 ? "auto" : _b;
    return $right;
}, function (_a) {
    var _b = _a.$left, $left = _b === void 0 ? "auto" : _b;
    return $left;
}, function (_a) {
    var _b = _a.$boxShadow, $boxShadow = _b === void 0 ? "none" : _b;
    return $boxShadow;
}, function (_a) {
    var _b = _a.$justifyContent, $justifyContent = _b === void 0 ? "normal" : _b;
    return $justifyContent;
}, function (_a) {
    var _b = _a.$border, $border = _b === void 0 ? "" : _b;
    return $border;
}, function (_a) {
    var _b = _a.$borderRadius, $borderRadius = _b === void 0 ? "0" : _b;
    return $borderRadius;
}, function (_a) {
    var _b = _a.$cursor, $cursor = _b === void 0 ? "default" : _b;
    return $cursor;
}, function (_a) {
    var _b = _a.$opacity, $opacity = _b === void 0 ? "1" : _b;
    return $opacity;
}, function (_a) {
    var _b = _a.$zindex, $zindex = _b === void 0 ? 0 : _b;
    return $zindex;
}, function (_a) {
    var _b = _a.$responsive, $responsive = _b === void 0 ? true : _b;
    return $responsive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (max-width: 768px) {\n        flex-direction: column;\n      }\n    "], ["\n      @media (max-width: 768px) {\n        flex-direction: column;\n      }\n    "])));
});
var BackgroundLayer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(", ") no-repeat center;\n  background-size: cover;\n  opacity: 0.2;\n  z-index: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(", ") no-repeat center;\n  background-size: cover;\n  opacity: 0.2;\n  z-index: 0;\n"])), function (props) { return props.$backgroundImage; });
var templateObject_1, templateObject_2, templateObject_3;
